import { deleted } from "../actions";

const deleteBook = (bookId) => {
  return async (dispatch, getState) => {
    const response = await fetch(`http://localhost:9000/books/${bookId}`, {
      method: "DELETE",
    });

    dispatch(deleted(bookId));
  };
};

export default deleteBook;
